export const PATH = {
  DROP_OFF_FEE_LIST: '/dropOffFees/list',
  DROP_OFF_FEE: '/dropOffFees',
}
